import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more\"><path d=\"M213.312 426.688a85.312 85.312 0 1 0 0 170.624 85.312 85.312 0 0 0 0-170.624zM426.688 512a85.312 85.312 0 1 1 170.624 0 85.312 85.312 0 0 1-170.624 0z m298.624 0A85.312 85.312 0 1 1 896 512a85.312 85.312 0 0 1-170.688 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol